import React, { useCallback } from 'react';
import { Icon, InputAdornment, TextField } from '@mui/material';
import styles from './CreateParentAccount.module.css';
import { MobileStepIndicator } from '../../../../component/signup/mobileStepIndicator/mobileStepIndicator';
import { CreateParentAccountElement } from '../CreateParentAccountElement';

export const MobileView = (): JSX.Element => {
  // Redux Hooks

  const createAccountElement = CreateParentAccountElement();
  return (
    <React.Fragment>
      <div className={styles.createAccountDiv}>
        <header className={styles.headerGroup} id="common-navi-bar">
          <img
            className={styles.bbaLogoIcon}
            id="entry-header"
            alt=""
            src="assets/common/bba-logo.svg"
          />
        </header>
        <main
          className={styles.createParentAccountMain}
          id="create-parent-account-main"
        >
          <section
            className={styles.createParentAccountTitleGrSection}
            id="create-parent-account-title-group"
          >
            <img
              className={styles.mobileBackIcon}
              id="mobile-back-icon"
              alt=""
              src="assets/common/mobile-back-icon.svg"
              onClick={createAccountElement.backButtonClickHandler}
            />
            <div className={styles.createParentAccountTitleDiv}>
              Create Account
            </div>
          </section>
          {/* <div className={styles.createParentAccountDivider}>
            <div className={styles.lineDiv} />
            <div className={styles.lineDiv1} />
            <div className={styles.oRDiv}>OR</div>
          </div> */}
          <div
            className={styles.createParentAccountInputHeDiv}
            id="create-parent-account-input-help-text"
          >
            <div className={styles.xCircleDiv} />
            <div className={styles.xCircleDiv} />
            <div className={styles.assistiveTextDiv}>
              Big Bang Academy uses the email address as the primary way to
              communicate with you.
            </div>
          </div>
          <div className={styles.createParentAccountEmailInTextField}>
            {createAccountElement.emailInput}
          </div>
          {/* <section
            className={styles.createAccountMainGroupContSection}
            id="create-account-main-group-content-social-login-group"
          >
            <div className={styles.createAccountMainGroupContDiv}>
              <img
                className={styles.createAccountMainGroupContIcon}
                id="create-account-main-group-content-social-login-facebook"
                alt=""
                src="assets/common/facebook-icon.svg"
              />
              <img
                className={styles.createAccountMainGroupContIcon1}
                id="create-account-main-group-content-social-login-apple"
                alt=""
                src="assets/common/apple-icon.svg"
              />
              <img
                className={styles.createAccountMainGroupContIcon2}
                id="create-account-main-group-content-social-login-google"
                alt=""
                src="assets/common/google-icon.svg"
              />
            </div>
            <div className={styles.createAccountMainGroupContDiv1}>
              Continue with Social Media
            </div>
          </section> */}
          <div className={styles.createParentAccountNextButButton}>
            <div className={styles.smallDiv}>
              {createAccountElement.continueButton}
            </div>
          </div>
        </main>
        <footer className={styles.progressIndicatorsFooter}>
          <MobileStepIndicator step={1} totalStep={4} />
        </footer>
      </div>
    </React.Fragment>
  );
};
